import styled from 'styled-components'
import {useContext,useState} from 'react'
import {OrderDataContext,OrderItemsContext,ErrorContext,WaiterContext} from './Context/WaiterContext'
import {format} from 'date-fns'
import Api from "../../api/api";
import { Text } from '@chakra-ui/react';

function Footer({page, setPage}) {
    const {order, setOrder} = useContext(OrderDataContext)
    const {orderItems, setOrderItems} = useContext(OrderItemsContext)
    const [loading, setLoading] = useState(false)
    const {waiter} = useContext(WaiterContext)
    const {errors, setErrors} = useContext(ErrorContext)

    const onConfirm = () => {
        setLoading(true)
        const orderData = order;
        orderData.date = format(new Date(order.date), 'y-MM-dd');
        orderData.time = format(new Date(), 'HH:mm');
        Api.saveWaiterOrder(waiter.slug, {
            order: orderData,
            items: orderItems,
        }).then(() => {
            setOrder({
                table: null,
                guests: null,
                location: null,
                comment: null,
                price: 0,
                success: false,
                time: format(new Date(), 'HH:mm'),
                date: new Date(),
            })
            setOrderItems({});
            Api.notify({
                text: 'Order created!',
                data: {
                    date: order.date,
                    time: order.time,
                }
            });
            setPage('fourth')
        }).catch((e) => {
            alert('error')
        }).finally(() => {
            setLoading(false)
        })
    }

    const moveToSecondPage = () => {
        let allow = true;
        if (!order.location) {
            allow = false;
            setErrors((prev) => ({...prev, location: true}))
        }
        if (!order.table) {
            allow = false;
            setErrors((prev) => ({...prev, table: true}))
        }

        if (allow) {
            setPage('second');
        }
    }

    const renderFooter = () => {
        if (page === 'first') {
            return <>
                <Button onClick={() => moveToSecondPage()}>Next step</Button>
                <br/>
            </>
        } else if (page === 'second') {
            return <>
                <Button onClick={() => setPage('third')}>Review order</Button>
                <br />
                <p>
                    Total amount of order is <strong>{order.price.toFixed(2)}€</strong>
                </p>
            </>
        } else if (page === 'third') {
            if (loading) {
                return <Text fontSize={24} disabled>Creating...</Text>
            }

            return <>
                <Button onClick={() => onConfirm()}>Send order to the kitchen!</Button>
            <br />
            <p>
                Total amount of order is <strong>{order.price.toFixed(2)}€</strong>
            </p>
        </>
        }
    }

    return (
        <Wrapper>
            {renderFooter()}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    background: #3F4041;
    color: #FFFFFF;
    display: flex;
    position: fixed;
    flex-direction: column;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px 45px;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 12px;
    z-index: 10;

    p {
        margin: 0;
    }
`;

const Button = styled.button`
    border: 0;
    padding: 10px;
    background-color: #AE996F;
    color: #fff;
    border-radius: 10px;
    width: 100%;
    max-width: 300px;
    font-size: 18px;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
`
export {Button}
export default Footer;
